import styled from 'styled-components'

export const OverlayContainer = styled.div<{ open?: boolean }>`
  width: 100vw;
  height: 100vh;

  background-color: var(--foreground---neutral, rgba(20, 23, 31, 0.6));

  display: flex;
  align-items: center;
  justify-content: center;

  opacity: ${({ open }) => (open ? 1 : 0)};

  transition: opacity 50ms ease-out;

  position: absolute;
  top: 0;
  left: 0;
`

export const Container = styled.div<{ open?: boolean }>`
  width: 100vw;
  height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;

  opacity: ${({ open }) => (open ? 1 : 0)};

  transition: opacity ${({ open }) => (open ? 150 : 100)}ms ease-out;

  position: absolute;
  top: 0;
  left: 0;
`

export const PopUpContainer = styled.form`
  width: 90%;
  max-width: 400px;

  max-height: calc(100vh - 16px);

  display: flex;
  flex-direction: column;
  align-items: center;

  border-radius: 12px;
  background: var(--persistent-white, #fff);
`

export const HeaderContainer = styled.header<{ hasChildren?: boolean }>`
  width: 100%;
  min-height: calc(53px + ${({ hasChildren }) => (hasChildren ? 42 : 0)}px);
  border-bottom: 1px solid var(--border-neutral-faded, #dfe2ea);
  padding: 8px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
`

export const HeaderTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const CloseButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  width: 36px;
  height: 36px;
  padding: 8px;
  box-sizing: border-box;

  cursor: pointer;

  svg {
    fill: var(--foreground-neutral, #14171f);
    transform: rotate(45deg);
  }
`

export const Title = styled.h1`
  padding: 0 8px;
  box-sizing: border-box;

  color: var(--foreground-neutral, #14171f);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`

export const ScrollContainer = styled.div<{ overflow: 'auto' | 'hidden' }>`
  width: 100%;
  height: calc(100% - 53px);

  overflow-y: ${({ overflow }) => overflow};
`

export const MainContainer = styled.main<{ fullScreen?: boolean }>`
  min-height: 100%;

  margin: 0 auto;
  width: 100%;
  max-width: ${({ fullScreen }) => (fullScreen ? '100%' : '720px')};

  display: flex;
`

export const BottomContainer = styled.footer`
  width: 100%;
  height: 69px;

  padding: 16px;
  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`

export const SubmitButton = styled.button<{ destroy?: boolean; disabled?: boolean }>`
  border: none;
  outline: none;

  display: flex;
  justify-content: center;
  align-items: center;

  height: 36px;
  padding: 8px 12px;
  box-sizing: border-box;

  border-radius: 6px;
  border: 1px solid
    ${({ destroy, disabled }) =>
      disabled
        ? 'var(--Foreground-Disabled, var(--Foreground-Disabled, #C7CDDB)'
        : destroy
        ? 'var(--Border-Critical, #cb101d)'
        : 'rgba(0, 0, 0, 0.20)'};
  background: ${({ destroy, disabled }) =>
    disabled
      ? 'var(--Background-Disabled, #ECEEF3)'
      : destroy
      ? 'linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(0, 0, 0, 0.3) 100%), #e22c2c'
      : // eslint-disable-next-line max-len
        'linear-gradient(180deg, rgba(255, 255, 255, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%), var(--Foreground-Secondary, #28B800)'};
  background-blend-mode: soft-light, normal;

  color: var(--On-background-Critical, #fff);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  cursor: pointer;
`

export const CancelButton = styled.button`
  border: none;
  outline: none;
  background-color: white;

  display: flex;
  justify-content: center;
  align-items: center;

  height: 36px;
  padding: 8px 12px;
  box-sizing: border-box;

  border-radius: 6px;

  color: var(--foreground-neutral, var(--foreground-neutral, #14171f));

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  cursor: pointer;
`

export const PreviousButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  padding: 8px;
  box-sizing: border-box;

  cursor: pointer;

  svg {
    fill: var(--foreground-neutral, #14171f);
  }
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
`
